module.exports = __webpack_public_path__ + "static/media/default_cover_image.cba3a915.jpg";